import { lazy, Suspense, useState } from 'react';
import { AspectRatio } from '@astryxdesign/core/AspectRatio';
import { Carousel } from '@astryxdesign/core/Carousel';
import { ClickableCard } from '@astryxdesign/core/ClickableCard';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import type { PublicTenant } from './schemas';

// The full-screen viewer is only needed after a tap.
const Lightbox = lazy(() => import('@astryxdesign/core/Lightbox').then((m) => ({ default: m.Lightbox })));

/** Photos of the studio's work: large swipeable cards, tap to view full screen with zoom. */
export function WorksGallery({ works }: { works: PublicTenant['works'] }) {
  const [open, setOpen] = useState<number | null>(null);
  const [viewerLoaded, setViewerLoaded] = useState(false);
  const media = works.map((w) => ({ src: w.url, alt: w.alt ?? w.caption ?? 'Фото работы', caption: w.caption ?? undefined }));
  return (
    <>
      <Carousel gap={3} hasSnap hasEdgeFade aria-label="Фото работ">
        {works.map((w, i) => (
          <ClickableCard
            key={w.id}
            label={`Открыть фото${w.caption ? `: ${w.caption}` : ''}`}
            padding={0}
            width={works.length === 1 ? '100%' : 288}
            className="app-work"
            onClick={() => {
              setViewerLoaded(true);
              setOpen(i);
            }}
          >
            <AspectRatio ratio={4 / 5}>
              <img src={w.url} alt={w.alt ?? w.caption ?? ''} loading="lazy" className="app-cover-img" />
            </AspectRatio>
            <VStack className="app-work-caption" gap={0.5}>
              <Text size="xsm" color="inherit" hasTabularNumbers>{i + 1} / {works.length}</Text>
              {w.caption ? <Text weight="semibold" color="inherit">{w.caption}</Text> : null}
            </VStack>
          </ClickableCard>
        ))}
      </Carousel>
      {viewerLoaded ? (
        <Suspense fallback={null}>
          <Lightbox isOpen={open !== null} onOpenChange={(o) => !o && setOpen(null)} media={media} index={open ?? 0} onIndexChange={setOpen} hasZoom />
        </Suspense>
      ) : null}
    </>
  );
}
